import './Tooltip.scss'
import right_icon from '../../../assets/icon-right.svg'
import icon_wallet from '../../../assets/wallet-icon-black.svg'
import { useLocation } from 'wouter'
import HeaderUserTooltip from '../HeaderUserTooltip/HeaderUserTooltip'

const TooltipUser = ({ isVisible, closeTooltipUser }) => {
  const [, setLocation] = useLocation()

  // Aqui lógica para el cierre de sesion
  const handleCloseSession = () => {
    setLocation('/')
  }

  const goToRoute = (route) => {
    setLocation(route)
    closeTooltipUser()
  }

  return (
    <div className={`header-toolip user ${isVisible ? 'visible' : ''}`} >
      <HeaderUserTooltip />
      <div className="toolip-divider"></div>
      <div className="header-toolip_links">
        <div className="header-toolip_link mb-10" onClick={() => goToRoute('/perfiles-roles/informacion-de-cuenta')}><img src={right_icon} alt="icon right" className="mr-5"/><p className="source-16 c-dark ">Acceso y seguridad</p></div>
        <div className="header-toolip_link mb-10" onClick={() => goToRoute('/campaigns/gestionar')}><img src={right_icon} alt="icon right" className="mr-5"/><p className="source-16 c-dark">Campañas activas</p></div>
        <div className="header-toolip_link " onClick={() => goToRoute('/dashboard')}><img src={right_icon} alt="icon right" className="mr-5"/><p className="source-16 c-dark">Recargar saldo en wallet</p></div>
      </div>
      <div className="toolip-divider"></div>
      <div className="wallet-container pt-10 pb-10" ><img src={icon_wallet} alt="icon wallet" className="mr-5"/><p className="source-16 c-dark sm-bold">Tu saldo en wallet: $50usd</p></div>
      <div className="toolip-divider m-hidden"></div>
      <div className="header-toolip_sesion">
        <p className="source-16 c-blue" onClick={handleCloseSession}>Cerrar sesion</p>
      </div>
    </div>
  )
}

export default TooltipUser
